import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { useCreateRecipe } from './useCreateRecipe'
import { RecipeForm } from './RecipeForm'

export function RecipeFormPage() {
  const { t } = useTranslation('recipes')
  const { mutate, isPending } = useCreateRecipe()

  return (
    <div className="px-4 pt-4 pb-24">
      <div className="flex items-center gap-3 mb-4">
        <Link to="/recipes" className="text-sm text-muted hover:text-ink min-h-[44px] flex items-center">
          ←
        </Link>
        <h1 className="text-xl font-bold text-ink">{t('create.title')}</h1>
      </div>
      <RecipeForm onSubmit={mutate} isPending={isPending} />
    </div>
  )
}
